import React from 'react';
import { authenticationService } from '@/_services';
import { toast } from 'react-hot-toast';
import queryString from 'query-string';

class TwoFactorPage extends React.Component {
  constructor(props) {
    super();

    this.state = {
      isLoading: false,
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleOnCheck = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };

  componentDidMount() {
    const user = authenticationService.currentUserValue;
    if (!user) {
      return this.props.history.push('/login');
    }
    if (user.isAuthenticatedFully) {
      return this.props.history.push('/');
    }
  }

  verifyCode = (e) => {
    e.preventDefault();

    this.setState({ isLoading: true });
    const { code } = this.state;

    authenticationService
      .authorizeTwoFactorCode(code)
      .then(this.verificationSuccessHandler, this.verificationFailureHandler);
  };

  verificationSuccessHandler = () => {
    authenticationService.deleteLoginOrganizationId();
    const params = queryString.parse(this.props.location.search);
    const { from } = params.redirectTo ? { from: { pathname: params.redirectTo } } : { from: { pathname: '/' } };
    const redirectPath = from.pathname === '/2fa' ? '/' : from;
    this.props.history.push(redirectPath);
    this.setState({ isLoading: false });
  };

  verificationFailureHandler = (res) => {
    toast.error(res.error || 'Invalid 2FA code', {
      id: 'toast-login-auth-error',
      position: 'top-center',
    });
    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;
    return (
      <div className="page page-center">
        <div className="container-tight py-2">
          <div className="text-center mb-4">
            <a href="." className="navbar-brand-autodark" data-cy="login-page-logo">
              <img src="/assets/images/logo-color.svg" height="26" alt="" />
            </a>
          </div>
          <form className="card card-md" action="." method="get" autoComplete="off">
            <div className="card-body">
              <div>
                <h2 className="card-title text-center mb-4" data-cy="login-page-header"></h2>
                <div className="mb-3">
                  <label className="form-label" data-cy="email-label">
                    Authenticator Code
                  </label>
                  <input
                    onChange={this.handleChange}
                    name="code"
                    type="text"
                    className="form-control"
                    placeholder="Code"
                    data-testid="smsCodeField"
                    data-cy="sms-code-text-field"
                  />
                </div>
              </div>
              <div className={`form-footer d-flex flex-column align-items-center`}>
                {' '}
                <button
                  onClick={this.verifyCode}
                  data-testid="verifyButton"
                  className={`btn btn-primary w-100 ${isLoading ? 'btn-loading' : ''}`}
                  data-cy="verify-button"
                >
                  Verify
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export { TwoFactorPage };
